<div class="price-information-container">
  <!-- Lowest Price Column -->
  <div class="price-column">
    <div class="price-box" [ngClass]="getLowestPriceColor()" [attr.title]="getLowestTooltip()">
      <div class="price">{{getLowestPriceFormatted()}}</div>
    </div>
    <div class="label">{{getString('lowest')}}</div>
  </div>

  <!-- Arrow with difference from lowest to current -->
  <div class="price-arrow">
    <span class="difference" [style.visibility]="getLowestToCurrentDifference() ? 'visible' : 'hidden'">{{getLowestToCurrentDifference() || '&nbsp;'}}</span>
    <span class="arrow arrow-right"></span>
  </div>

  <!-- Current Price Column -->
  <div class="price-column">
    <div class="price-box" [ngClass]="getCurrentPriceColor()" [attr.title]="getCurrentTooltip()">
      <div class="price">{{getCurrentPriceFormatted()}}</div>
    </div>
    <div class="label">{{getString('current')}}</div>
  </div>

  <!-- Arrow with difference from current to highest -->
  <div class="price-arrow">
    <span class="difference" [style.visibility]="getCurrentToHighestDifference() ? 'visible' : 'hidden'">{{getCurrentToHighestDifference() || '&nbsp;'}}</span>
    <span class="arrow arrow-left"></span>
  </div>

  <!-- Highest Price Column -->
  <div class="price-column">
    <div class="price-box" [ngClass]="getHighestPriceColor()" [attr.title]="getHighestTooltip()">
      <div class="price">{{getHighestPriceFormatted()}}</div>
    </div>
    <div class="label">{{getString('highest')}}</div>
  </div>
</div>
